export const CURRENT_QUEUE_CHANGED = 'CURRENT_QUEUE_CHANGED'
export const CURRENT_QUEUE_NEW_STATUS = 'CURRENT_QUEUE_NEW_STATUS'
export const EMPTY_QUEUES_LIST = 'EMPTY_QUEUES_LIST'
export const LOAD_QUEUES_SUCCESS = 'LOAD_QUEUES_SUCCESS'
export const PAUSE_WARM = 'PAUSE_WARM'
export const RESET_QUEUE_PAGE = 'RESET_QUEUE_PAGE'
export const RESUME_WARM = 'RESUME_WARM'
export const SET_CURRENT_QUEUE = 'SET_CURRENT_QUEUE'
export const SET_QUEUE_PAGE = 'SET_QUEUE_PAGE'
export const SET_QUEUE_PAGE_YEAR = 'SET_QUEUE_PAGE_YEAR'
export const SET_QUEUE_PAGE_MONTH = 'SET_QUEUE_PAGE_MONTH'
export const STOP_WARM = 'STOP_WARM'



// WEBPACK FOOTER //
// ./src/modules/queues/action-types.js